const REFRESH_SESSION_HINT_KEY = 'auth_refresh_session';
const DIRECT_ACCESS_TOKEN_KEY = 'auth_direct_access_token';

export const hasRefreshSessionHint = () => {
  return localStorage.getItem(REFRESH_SESSION_HINT_KEY) === '1';
};

export const markRefreshSessionHint = () => {
  localStorage.setItem(REFRESH_SESSION_HINT_KEY, '1');
};

export const clearRefreshSessionHint = () => {
  localStorage.removeItem(REFRESH_SESSION_HINT_KEY);
};

export const setDirectAccessToken = token => {
  sessionStorage.setItem(DIRECT_ACCESS_TOKEN_KEY, token);
};

export const getDirectAccessToken = () => {
  return sessionStorage.getItem(DIRECT_ACCESS_TOKEN_KEY);
};

export const isImpersonationSession = () => {
  return !!getDirectAccessToken();
};

export const clearDirectAccessToken = () => {
  sessionStorage.removeItem(DIRECT_ACCESS_TOKEN_KEY);
};
